<template>
    <div class="wrapper">
        <div class="header">
            <BaseHeader :title="'签到记录'"/>
        </div>
        <div class="content">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
                <div class="sign-item" v-for="item in signInList" :key="item.id">
                    <div>
                        <div class="timer">{{item.created_at}}</div>
                        <div class="title">来自：{{item.title}}</div>
                    </div>
                    <div class="price">
                        +{{item.amount}}
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import BaseHeader from "../components/BaseHeader";
    import {getSignInHistory} from '../service/userService';
    import {Toast} from 'vant';
    import {mapState} from 'vuex';
	//import {wecharShare} from "../util/weChat.js";

    export default {
        name: "UserSignInHistory",
        data(){
            return{
                signInList:[],
                loading: false,
                finished: false,
                offset:{
                    page:1,
                    limit:10,
                },
            }
        },
		mounted() {
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
		},
        methods:{
            getData(){
                getSignInHistory(this.userId,this.offset.page,this.offset.limit).then(res => {
                    if(res.status === 1){
                        this.loading = false;
                        if(res.datas.length === 0){
                            this.finished = true;
                            return;
                        }
                        this.signInList = [... this.signInList,...res.datas];
                        this.offset.page++;
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
        },
        components : {
            BaseHeader
        },
        computed:{
            ...mapState({
                userId: state => state.userInfo.userId,
            })
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        .content{
            background: #ffffff!important;
            padding: 10px 20px;
            box-sizing: border-box;
            .sign-item{
                padding: 10px 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &:not(:last-child){
                    border-bottom: 1px solid rgba(240,240,240,1);;
                }
                .timer{
                    color: #202020;
                }
                .title{
                    color: #202020;
                    font-size: 14px;
                    margin-top: 5px;
                }
                .price{
                    color: #EF000C;
                    font-size: 16px;
                }
            }
        }
    }
</style>